<script setup lang="ts">
definePageMeta({ layout: 'default' })

useHead({
  title: 'Statistiken',
  meta: [
    {
      name: 'description',
      content: 'Statistiken zu Bahnverspätungen in Deutschland.'
    }
  ]
})
</script>

<template>
  <div class="row g-2 justify-content-center my-5">
    <div class="col-xxl-6 col-xl-7 col-lg-8 col-md-11 hyphenate">
      <h1>Statistiken</h1>
      <p>
        Wer wollte alles schon mal wissen wie pünktlich die Bahn gestern war? Oder welche
        Zugstrecken besonders zuverlässig sind? Wir sammeln rund um die Uhr die
        Verspätungsinformationen aus den Bahnverkehrsdaten, um diese in unsere Verbindungsvorhersage
        zu integrieren. Hier an dieser Stelle veröffentlichen wir auch unsere selbst erstellten
        Statistiken zur Pünktlichkeit im Bahnverkehr.
      </p>
      <NuxtLink
        class="btn btn-primary w-100 mb-3"
        :to="{ path: '/stats/overview', hash: '#content' }"
        >Übersicht</NuxtLink
      >
      <NuxtLink
        class="btn btn-primary w-100 mb-3"
        :to="{ path: '/stats/stations', hash: '#content' }"
        >Bahnhöfe</NuxtLink
      >
      <em class="text-muted">
        Disclaimer: Alle diese Daten sind eine Beobachtung von dritten und nicht von der Bahn
        selber. Wir können die Richtigkeit der Daten nicht garantieren. In den vielen von uns
        erstellten Auswertungen der Daten haben wir einige kleinere Fehler gefunden. Diese können
        wir nicht korrigieren, da wir nicht an bessere Daten herankommen. Wer belastbare Statistiken
        sucht, muss selber direkt bei der Bahn nachfragen.
      </em>
    </div>
  </div>
</template>
